<div class="capacity-settings">
	<div fxLayout="row" fxLayoutGap="1rem">
		<mat-form-field class="m-t-0-4" fxFlex="100">
			<mat-label>Trailer Types</mat-label>
			<mat-select
				(selectionChange)="handleTrailerTypesChange($event)"
				[(ngModel)]="defaultSettings.defaultTrailerTypes"
				multiple
			>
				<mat-option
					*ngFor="let trailer of defaultSettings.searchableTrailerTypes"
					[value]="trailer.value"
				>
					{{ trailer.value }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field class="m-t-0-4" fxFlex="100">
			<mat-label>Pickup Date</mat-label>
			<mat-select
				(selectionChange)="handleDefaultPickupDateTypeChange($event)"
				[(ngModel)]="defaultSettings.defaultPickupDateType"
			>
				<mat-option
					*ngFor="let pickupDate of defaultSettings.pickupDateTypes"
					[value]="pickupDate.value"
				>
					{{ pickupDate.value }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<div fxLayout="row" fxLayoutGap="1rem">
		<div class="row top-margin" fxFlex="100" fxLayout="row">
			<div class="m-r-1 font-size-13 font-weight-bold primary-text" fxFlex="100">
				Origin Deadhead
			</div>
			<div class="primary-text" fxFlex="100" fxLayout="row">
				<mat-icon
					(click)="
						sliderButtonClicked(
							CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER,
							'searchTruckOriginDeadheadLimit',
							-SLIDER_STEP_SIZE
						)
					"
					class="cursor-pointer"
					color="primary"
				>
					remove
				</mat-icon>
				<mat-slider
					(change)="
						sliderChanged(
							CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER,
							defaultSettings.searchTruckOriginDeadheadLimit
						)
					"
					[(ngModel)]="defaultSettings.searchTruckOriginDeadheadLimit"
					[max]="SLIDER_RANGE.max"
					[min]="SLIDER_RANGE.min"
					[ngModelOptions]="{ standalone: true }"
					[step]="SLIDER_STEP_SIZE"
					[thumbLabel]="true"
					color="primary"
					fxFlex="100"
				>
				</mat-slider>
				<mat-icon
					(click)="
						sliderButtonClicked(
							CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER,
							'searchTruckOriginDeadheadLimit',
							SLIDER_STEP_SIZE
						)
					"
					class="cursor-pointer"
					color="primary"
				>
					add
				</mat-icon>
			</div>
		</div>
		<div class="row top-margin" fxFlex="100" fxLayout="row">
			<div class="font-size-13 font-weight-bold primary-text" fxFlex="100">
				Destination Deadhead
			</div>
			<div class="primary-text" fxFlex="100" fxLayout="row">
				<mat-icon
					(click)="
						sliderButtonClicked(
							CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER,
							'searchTruckDestinationDeadheadLimit',
							-SLIDER_STEP_SIZE
						)
					"
					class="cursor-pointer"
					color="primary"
				>
					remove
				</mat-icon>
				<mat-slider
					(change)="
						sliderChanged(
							CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER,
							defaultSettings.searchTruckDestinationDeadheadLimit
						)
					"
					[(ngModel)]="defaultSettings.searchTruckDestinationDeadheadLimit"
					[max]="SLIDER_RANGE.max"
					[min]="SLIDER_RANGE.min"
					[ngModelOptions]="{ standalone: true }"
					[step]="SLIDER_STEP_SIZE"
					[thumbLabel]="true"
					color="primary"
					fxFlex="100"
				>
				</mat-slider>
				<mat-icon
					(click)="
						sliderButtonClicked(
							CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER,
							'searchTruckDestinationDeadheadLimit',
							SLIDER_STEP_SIZE
						)
					"
					class="cursor-pointer"
					color="primary"
				>
					add
				</mat-icon>
			</div>
		</div>
	</div>

	<div fxLayout="row" fxLayoutGap="1rem">
		<div class="full-width row top-margin" fxFlex>
			<div class="font-size-13 font-weight-bold primary-text" fxFlex>Minimum Truck Count</div>
			<mat-form-field fxFlex>
				<input
					(input)="handleMinimumTruckCountChange($event)"
					[(ngModel)]="defaultSettings.minimumTruckCount"
					autocomplete="off"
					matInput
					min="0"
					type="number"
				/>
			</mat-form-field>
		</div>
		<div class="full-width row top-margin" fxFlex>
			<div class="font-size-13 font-weight-bold primary-text" fxFlex>Minimum Frequency</div>
			<mat-form-field fxFlex>
				<input
					(input)="handleMinimumFrequencyChange($event)"
					[(ngModel)]="defaultSettings.minimumFrequency"
					autocomplete="off"
					matInput
					min="0"
					type="number"
				/>
			</mat-form-field>
		</div>
	</div>
	<div>
		<mat-form-field class="m-t-0-4" fxFlex="100">
			<mat-label>Capacity Search Tab</mat-label>
			<mat-select
				(selectionChange)="handleDefaultCapacitySearchTabChange($event)"
				[(ngModel)]="defaultSettings.defaultCapacitySearchTab"
			>
				<mat-option
					*ngFor="let capacitySearchTab of defaultSettings.capacitySearchTabs"
					[value]="capacitySearchTab"
				>
					{{ capacitySearchTab }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</div>
